export default __webpack_public_path__ + "static/media/050-basketball.c2f535a6.svg";